import { render } from "./amountSelect.vue?vue&type=template&id=4ed8a5da"
import script from "./amountSelect.vue?vue&type=script&lang=js"
export * from "./amountSelect.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jx/project/wld/nongxin-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__